import {JSX} from "react";

import "./styles/select-search.scss";

interface SelectSearchProps {
    value: string;
    onChange: (value: string) => void;
}

export function SelectSearch({value, onChange}: SelectSearchProps): JSX.Element {
    return (
        <div className="select-field__search">
            <input
                type="text"
                value={value}
                onChange={(e) => onChange(e.target.value)}
                placeholder="Search..."
                className="select-field__search-input"
            />
        </div>
    );
}
